import React from 'react';

export const FAQ: React.FC = () => (
    <div>
        <h2>What is Stackulator?</h2>
        <p>
            Stackulator is a simple tool for roughly estimating costs and rewards from stacking on Blockstack platform.
        </p>
        <br />
        <h2>What is Blockstack?</h2>
        <p>
            Blockstack is an open-source platform for building user-owned internet. Unlike traditional web apps,
            Blockstack apps respect user privacy and can share some of the value with its users. This is possible thanks
            to native Stacks blockchain which is anchored to Bitcoin security and clarity smart contract language.
        </p>
        <br />
        <h2>What is Stacking?</h2>
        <p>
            Stacking is a process of locking STX tokens for improving the security of Stacks blockchain. As a reward you
            can earn Bitcoin. Token you stack never leave your wallet and are under your full control at all times.
        </p>
        <br />
        <h2>What is STX Token?</h2>
        <p>
            STX is a native token of a Stacks blockchain qualified by
            <a href="https://en.wikipedia.org/wiki/U.S._Securities_and_Exchange_Commission"> SEC</a>. It's used to pay
            miners for transactions, running smart contracts, registering user-owned identity data, etc. You can trade
            it on
            <a href="https://www.binance.com/en/trade/STX_BTC"> Binance</a>,
            <a href="https://trade.kucoin.com/spot"> KuCoin</a> and
            <a href="https://pro.hashkey.com/SelectMarket/#/?_k=kqk6jm"> HashKey</a>.
        </p>
        <br />
        <h2>What's the relationship between Stacking and Mining?</h2>
        <p>
            Miners are spending their Bitcoin to update Stacks chain. They earn native STX tokens from block rewards and
            transaction fees. Stackers are helping Miners by providing information about the network. In return, they
            receive Bitcoin from miners.
        </p>
        <br />
        <h2>How much can I earn?</h2>
        <p>
            That depends on the amount of STX token you stack, how active the stacks network is, what is the price of
            STX and Bitcoin.
        </p>
        <br />
        <h2>Where is the catch?</h2>
        <p>
            There are inherent risks with every blockchain platform - price volatility, early-stage tech, user adoption.
            By participating in Blockstack you are joining a group of pioneers on cutting edge tech. I recommend
            educating yourself.
        </p>
        <br />

        <div>
            <ul style={{ paddingLeft: '20px' }}>
                <li>
                    <span>To learn more about Blockstack visit </span>
                    <a href="https://blockstack.org/" target="_blank" rel="noopener noreferrer">
                        Blockstack page
                    </a>
                </li>
                <li>
                    <span>To try some of the apps </span>
                    <a href="https://app.co/" target="_blank" rel="noopener noreferrer">
                        visit the app store
                    </a>
                </li>
                <li>
                    <span>To develop your own app read </span>
                    <a href="https://docs.blockstack.org/" target="_blank" rel="noopener noreferrer">
                        developer docs
                    </a>
                </li>
                <li>
                    <span>In case of any questions ask the community on </span>
                    <a href="https://t.me/blockstack" target="_blank" rel="noopener noreferrer">
                        Telegram
                    </a>
                    <a href="https://forum.blockstack.org/" target="_blank" rel="noopener noreferrer">
                        , Forums
                    </a>
                    <span> or </span>
                    <a href="https://community.blockstack.org/discord" target="_blank" rel="noopener noreferrer">
                        Discord
                    </a>
                </li>
            </ul>
        </div>
    </div>
);

export default FAQ;
